import React from "react";
import { getObjectUseCase, upsertUseCase } from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import FormFactory from "../../components/FormFactory";
import ApplicationStatusPresenter from "./ApplicationStatusPresenter";
import { Link } from "react-router-dom";
import schemaIdForm from "./schemas-status/schemaIdForm.json";
import schemaOtherDocs from "./schemas-status/schemaOtherDocs.json";
import schemaPersonalForm1 from "./schemas-status/schemaPersonalForm1.json";
import schemaContactPerson from "./schemas-status/schemaContactPerson.json";
import schemaContactPersonAddress from "./schemas-status/schemaContactPersonAddress.json";
import schemaEmployment from "./schemas-status/schemaEmployment.json";
import schemaCharacterRef from "./schemas-status/schemaCharacterRef.json";
import schemaPersonalForm2 from "./schemas-status/schemaPersonalForm2.json";
import schemaElementaryForm from "./schemas-status/schemaElementaryForm.json";
import schemaHSForm from "./schemas-status/schemaHSForm.json";
import schemaColForm from "./schemas-status/schemaColForm.json";
import schemaDocForm from "./schemas-status/schemaDocForm.json";
import InputFactory from "../../components/InputFactory";
import schemaPresentAddress from "./schemas-status/schemaPresentAddress.json";
import schemaPermanentAddress from "./schemas-status/schemaPermanentAddress.json";

class ApplicationFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      isAddressSame: false,
      employmentForm: [],
    };
    this.presenter = new ApplicationStatusPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  onChangeEmployment(value, field) {
    this.presenter.onChangeEmployment(value, field);
  }

  onChangecharacteref(value, field) {
    this.presenter.onChangecharacteref(value, field);
  }

  getCollectionName() {
    const typeOfApplication = this.getApplicationType();
    switch (typeOfApplication) {
      case "online":
        return "online_applicants";
        break;
      case "walkIn":
        return "walkIn_applicants";
        break;
      default:
        return "reprocess_applicants";
        break;
    }
  }

  getApplicationType() {
    return this.props.params.type;
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeLGS(event) {
    const value = event.target.value;
    this.setState({ whereLGSSee: event.target.value });
  }

  toggleCheckbox(event) {
    const isChecked = event.target.checked;
    this.setState({ isAddressSame: isChecked });
  }

  toggleDropdown() {
    this.setState((prevState) => ({
      isschoolRecord: !prevState.isschoolRecord,
    }));
  }

  seeOrientationForm() {
    const { object } = this.state;
    this.navigateTo(
      `/orientation/form/${object?.interviewCoordinator}/${object?.id}`
    );
  }

  render() {
    const {
      isAddressSame,
      whereLGSSee,
      selectedOptions,
      uploadedFiles,
      selectedNames,
      isschoolRecord,
      object,
    } = this.state;

    console.log(object);

    return (
      <>
        <div
          style={{
            marginTop: `3.5rem`,
            overflowY: `hidden`,
            backgroundColor: `#F8F8F8`,
          }}
          className="pt-5 p-2 p-md-5"
        >
          <div className="d-flex flex-column">
            <div className="d-flex flex-column flex-md-row justify-content-between align-content-center">
              <div className="d-flex gap-2 ms-2">
                <Link to="/application-status">
                  <i
                    class="bi bi-arrow-left fs-4"
                    style={{ color: `#303030CC` }}
                  ></i>
                </Link>
                <h1 className="fs-2 fw-bold" style={{ color: `#D18237` }}>
                  Application Form
                </h1>
              </div>

              {object?.status === "On-boarding" ||
              object?.status === "Hired" ? (
                <button
                  className="p-2 text-white rounded-1 border-0 fw-bold px-4"
                  style={{ backgroundColor: `#D18237` }}
                  onClick={this.seeOrientationForm.bind(this)}
                >
                  Orientation Form
                </button>
              ) : (
                ""
              )}
            </div>
            <div className="d-flex flex-column">
              <div className="bg-white mt-4 p-4 rounded-3 d-flex flex-column gap-0">
                <form>
                  <p className="fs-5 fw-bold p-0 m-0">Instructions:</p>
                  <p className="p-0 m-0">
                    1. Answer ALL questions completely and accurately.
                  </p>
                  <p className="p-0 m-0">
                    2. Provide all information to the best of your knowledge.
                  </p>
                  <div className="d-flex w-100 flex-column flex-column-reverse flex-md-row justify-content-between">
                    <div className="d-flex flex-column col-md-4 col-lg-3 align-items-start mt-3 gap-2">
                      <div className="d-flex flex-column gap-2 w-100">
                        <b>Where did you see LGS?</b>
                        <InputFactory
                          type="String"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="seeLGS"
                          defaultValue={object.seeLGS}
                          disabled
                        />
                        {whereLGSSee === "Recruiter" ? (
                          <div>
                            <select className="form-control bg-light-subtle p-2">
                              <option selected disabled>
                                Select Recruiter
                              </option>
                            </select>
                          </div>
                        ) : (
                          <div className="d-flex flex-column">
                            <p className="text-muted m-0 p-0">
                              Position/s Applied for:
                            </p>

                            <InputFactory
                              type="String"
                              required
                              className="form-control bg-light-subtle p-2"
                              placeholder="Select"
                              field="positionApplied"
                              defaultValue={object.positionApplied}
                              disabled
                            />
                          </div>
                        )}
                      </div>
                      <div className="mt-2 w-100">
                        <b>Do you have any relative in:</b>
                        <div className="mt-2">
                          <label className="form-label fs-sm">LGS</label>
                          <InputFactory
                            type="String"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeLGS"
                            defaultValue={object.relativeLGS}
                            disabled
                          />
                        </div>
                        <div>
                          <label className="form-label fs-sm">Client</label>
                          <InputFactory
                            type="String"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeClient"
                            defaultValue={object.relativeClient}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-3 col-lg-6">
                      <label className="fw-bold">
                        Applicant's Image
                        <span className="text-danger fw-lighter ms-1">*</span>
                      </label>
                      {object?.image1 ? (
                        <div
                          className="border-1 border rounded-3 position-relative col-sm-6"
                          style={{ width: "300px", height: "300px" }}
                        >
                          <img
                            className="w-100 h-100 rounded-1 object-fit-contain"
                            src={`${object?.image1}`}
                            alt="Uploaded file"
                          ></img>
                        </div>
                      ) : (
                        <div className="border-1 border rounded-3 position-relative col-sm-6 bg-light-subtle">
                          <a href="#uploadImage">
                            <img
                              className="w-100"
                              src="/defaultImage.png"
                              alt="Default Image"
                            ></img>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mt-5">
                    <b>Personal Information</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaPersonalForm1}
                      object={object}
                      disabled
                    />
                    <FormFactory
                      schema={schemaPersonalForm2}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="mt-4">
                      <b>Permanent Address</b>
                    </div>
                    <FormFactory
                      schema={schemaPermanentAddress}
                      object={object}
                      disabled
                    />
                  </div>
                  {isAddressSame ? (
                    <div className="row justify-content-md-start mt-3">
                      <div className="col-md-5 d-flex gap-2">
                        <input
                          type="checkbox"
                          className="cursor-pointer"
                          checked={isAddressSame}
                          disabled
                        />
                        <p className="m-0 p-0">
                          Permanent Address same as a Present Address
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {isAddressSame ? (
                    ""
                  ) : (
                    <div className="row justify-content-md-start mt-3">
                      <div className="mt-4">
                        <b>Present Address</b>
                      </div>
                      <FormFactory
                        schema={schemaPresentAddress}
                        object={object}
                        disabled
                      />
                    </div>
                  )}

                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaIdForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>Emergency Contact Person</b>
                    <hr></hr>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaContactPerson}
                      object={object}
                      disabled
                    />

                    <FormFactory
                      schema={schemaContactPersonAddress}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>Educational Information</b>
                    <hr />
                  </div>
                  {/* <div className="mt-4">
                    <b>Elementary</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaElementaryForm}
                      object={object}
                      disabled
                    />
                  </div> */}

                  <div className="mt-4">
                    <b>High School</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaHSForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>College</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaColForm}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex">
                      <InputFactory
                        type="Boolean"
                        field="isFreshGrad"
                        label="Fresh Graduate"
                        object={object}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <b>Employment Background</b>
                    <hr />
                  </div>
                  <div>
                    <div className="row justify-content-md-start mt-3">
                      <div className="row justify-content-md-start mt-3">
                        {object.employmentBackground?.map(
                          (employment, index) => (
                            <FormFactory
                              schema={schemaEmployment}
                              object={employment}
                              disabled
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-3">
                    <b>Character References</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <div className="row justify-content-md-start mt-3">
                      {object.characterReferences?.map((reference, index) => (
                        <FormFactory
                          schema={schemaCharacterRef}
                          disabled
                          object={reference}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="mt-4">
                    <b>School Record</b>
                    <hr />
                  </div>

                  <div className="d-flex flex-row justify-content-md-start mt-3 gap-3">
                    {object?.diploma ? (
                      <div className="col-lg-3">
                        <label>Diploma</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Diploma"
                          field="diploma"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.tor ? (
                      <div className="col-lg-3">
                        <label>TOR</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="TOR"
                          field="tor"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.reportCard ? (
                      <div className="col-lg-3">
                        <label>Report Card</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Report Card"
                          field="reportCard"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.graduationCertificate ? (
                      <div className="col-lg-3">
                        <label>Graduation Certificate</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Graduation Certificate"
                          field="graduationCertificate"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-4">
                    <b>Upload Documents</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaDocForm}
                      disabled
                      object={object}
                    />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaOtherDocs}
                      disabled
                      object={object}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ApplicationFormPage);
